module.exports=function(scope){ return `curl -X POST \
'https://your.internal.zoomserver.instance.url/match-3d-2d' \
-H 'Content-Type: application/json' \
-H 'X-User-Agent: INSERT_X_USER_AGENT_VALUE_HERE' \
-d '{
    "source": {
        "enrollmentIdentifier": "INSERT_ENROLLMENT_IDENTIFIER_FOR_3D_FACEMAP_HERE"
    },
    "target": {
        "image": "INSERT_2D_FACEMAP_AS_BASE64_HERE"
    }
}'
`};


// WEBPACK FOOTER //
// ./src/resources/code/standard-server/bash/compare-3d-2d.bash.tpl